
<template>
<div>
  <div v-if="!isLoading" class="">
    <div v-if="item" class="">
      <div class="row">
        <div class="col-12"> 
          <div class="card mb-5">
            <div class="card-header d-flex justify-content-between align-items-center">
              <h5 class="card-title mb-0">Payment status</h5>
              <div class="dropdown dropstart no-arrow">
                <button class="dropdown-toggle btn btn-sm btn-light" type="button"
                  role="button" data-bs-toggle="dropdown" aria-expanded="false">
                  <i class="ri-more-2-fill"></i>
                </button>
                <ul class="dropdown-menu">
                  <li>
                    <button @click="generateReceipt()" class="dropdown-item"
                    type="button" >
                    Print receipt</button>
                  </li>
                </ul>
              </div>
            </div>
            <div class="card-body position-relative">
              <div  class="row g-4"> 
                <div class="col-sm-6">
                  <label class="small text-muted">Status</label>
                  <p class="mb-0"><span v-html="statusBadge(item.status)"></span></p>
                </div>
                <div class="col-sm-6">
                  <label class="small text-muted">Selected on</label>
                  <p class="mb-0">{{ $filters.date(item.created_at,1) }}</p>
                </div>
                <div class="col-sm-6">
                  <div v-if="item.status == 'accepted_payment'">
                    <label class="small text-muted">Accepted on</label>
                    <p class="mb-0">{{ $filters.date(item.accepted_at, 1) }}</p>
                  </div>
                  <div v-if="item.status == 'rejected_payment'">
                    <label class="small text-muted">Rejected on</label>
                    <p class="mb-0">{{ $filters.date(item.rejected_at, 1) }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="item.status === 'pending_acceptance'" class="bd-callout mt-0 mb-5 bd-callout-warning">
            <accept-payment-form 
            :edit-item="item"
            @updateItem="updateItem($event)"/>
          </div>
          <div v-else class="bd-callout mt-0 mb-5 bd-callout-info">
            <h4>Your Payment Receipt. </h4>
            <div class="pt-4">
              <p class="mb-1">
                You can download your payment receipt as a proof. 
              </p>
              <div class="mt-3">
                <button @click="generateReceipt()" class="btn btn-primary"  type="button" >Print Receipt</button>
              </div>
            </div>
          </div>
          <div v-if="item.payment" class="card mb-5 overflow-hidden">
            <div class="card-header d-flex justify-content-between align-items-center">
              <h5 class="card-title mb-0">Payment Details</h5>
            </div>
            <div class="card-body">
              <div class="row g-3 g-lg-4">
                <div class="col-lg-6">
                  <label class="small text-muted">Payment ID</label>
                  <p class="mb-0">{{ item.payment.friendly_id }}</p>
                </div>
                <div class="col-lg-6">
                  <label class="small text-muted">Title</label>
                  <p class="mb-0">{{item.payment.title}}</p>
                </div>
                <div class="col-sm-6">
                  <label class="small text-muted">Amount</label>
                  <p  class="mb-0">{{ $filters.money_format(item.payment.amount) }} {{ item.payment.currency }} </p>
                </div>
                <div class="col-sm-6">
                  <label class="small text-muted">Transfer reference</label>
                  <p  class="mb-0">{{ item.transfer_reference }} </p>
                </div>
                <div class="col-sm-6">
                  <label class="small text-muted">Transferred at</label>
                  <p  class="mb-0">{{ $filters.date(item.transferred_at,1) }} </p>
                </div>
                <div class="col-12">
                  <label class="small text-muted">Description</label>
                  <div v-html="preText(item.payment.description)" class="mb-0"></div>
                </div>
                <div v-if="item.payment.closed_at" class="col-sm-6">
                  <label class="mb-0 text-muted">Closed at</label>
                  <p class="mb-0 mt-2 pt-1 text-muted">{{ $filters.date(item.payment.closed_at, 1) }}</p>
                </div>
                <div v-if="item.payment.canceled_at" class="col-sm-6">
                  <label class="mb-0 text-muted">Canceled at</label>
                  <p class="mb-0 mt-2 pt-1 text-muted">{{ $filters.date(item.payment.canceled_at, 1) }}</p>
                </div>
              </div>          
            </div>
          </div>
          <div v-if="item.opportunity">
            <opportunity-detail-card  :item="item.opportunity" />
          </div>
        </div>
      </div>
    </div>
  </div>
  <is-loading v-else />
</div>
</template>

<script>
import IsLoading from '@/components/IsLoading.vue'
import OpportunityDetailCard from '@/components/cards/OpportunityDetailCard.vue'
import AcceptPaymentForm from '@/components/forms/AcceptPaymentForm.vue'

export default {
  name: "payment-show",
  components:{
    IsLoading,
    OpportunityDetailCard,
    AcceptPaymentForm,
  },
  data() {
    return {
      isLoading: true,
      popupModalShow: false,
      item: null,
    }
  },
  watch: {
    '$route.params.recipientId': function (id){
      if(id) this.fetchItem()
    },
  },
  methods: {
    updateItem(item){
      this.item = Object.assign(this.item, item);
    },
    fetchItem(){
      this.isLoading = true
      this.$http.get(`/payment-recipients/${this.$route.params.recipientId}/show`)
      .then((response) => {
        this.isLoading = false
        if(response.data.success){
          this.item = response.data.data
        }else{
          this.$router.push({path: '/error-404'})
        }
      })
    },
    generateReceipt(){
      const payload = {
        url: `/payment-recipients/${this.item.id}/slip`,
        data: {}
      }
      this.$store.dispatch("changeLoaderValue", true)
      this.pdfFileExport(payload)
        .then((response) => {
          this.$store.dispatch("changeLoaderValue", false)
        }).catch((error) => {
          this.$store.dispatch("changeLoaderValue", false)
        })
    
    },
    initializeAll(){
      this.popupModalShow = false;
    }
  },
  created(){
    this.fetchItem()
  },
}

</script>

